"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    icon: {
        marginLeft: theme.spacing(4),
        zIndex: 11,
    }
}); });
exports.default = useStyles;
